// ISDP CUSTOM: Entire file — Admin plugin registration (mounted at /admin in App.tsx, gated by RequirePermission).
// Four routed pages after the admin consolidation:
//   Overview (root) · Analytics (insights) · Curation · Access.
// Analytics and Curation are tabbed wrappers; their sub-views are plain components
// rendered inline (see AnalyticsPage / CurationHubPage), not routable extensions.
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import {
  rootRouteRef,
  insightsRouteRef,
  curationRouteRef,
  accessRouteRef,
} from './routes';

export const adminPlugin = createPlugin({
  id: 'admin',
  routes: {
    root: rootRouteRef,
    insights: insightsRouteRef,
    curation: curationRouteRef,
    access: accessRouteRef,
  },
});

export const AdminPage = adminPlugin.provide(
  createRoutableExtension({
    name: 'AdminPage',
    component: () =>
      import('./components/AdminPage').then(m => m.AdminPage),
    mountPoint: rootRouteRef,
  }),
);

export const AnalyticsPage = adminPlugin.provide(
  createRoutableExtension({
    name: 'AnalyticsPage',
    component: () =>
      import('./components/AnalyticsPage/AnalyticsPage').then(
        m => m.AnalyticsPage,
      ),
    mountPoint: insightsRouteRef,
  }),
);

export const CurationHubPage = adminPlugin.provide(
  createRoutableExtension({
    name: 'CurationHubPage',
    component: () =>
      import('./components/CurationHubPage/CurationHubPage').then(
        m => m.CurationHubPage,
      ),
    mountPoint: curationRouteRef,
  }),
);

export const AccessManagementPage = adminPlugin.provide(
  createRoutableExtension({
    name: 'AccessManagementPage',
    component: () =>
      import('./components/AccessManagementPage/AccessManagementPage').then(
        m => m.AccessManagementPage,
      ),
    mountPoint: accessRouteRef,
  }),
);
